export default "__VITE_ASSET__CTWSc6gB__"